export const CLIENT_ID_NOVUM = 'novum-mytelco';
// include here more client ids as needed

export type ClientId = typeof CLIENT_ID_NOVUM;
